import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { resolveSeriesLandingPath } from '../utils/seriesLanding';

/**
 * Leftover Series Notes /dashboard and /series-bible are not a working
 * front door (#682). Apply the same first-open lock: empty → Series
 * Discovery, pins → Timeline.
 */
function SeriesLandingRedirect({ projectId }) {
  const [to, setTo] = useState(null);

  useEffect(() => {
    if (!projectId) {
      setTo('/projects');
      return undefined;
    }
    let cancelled = false;
    resolveSeriesLandingPath({ id: projectId }).then((path) => {
      if (!cancelled) setTo(path);
    });
    return () => { cancelled = true; };
  }, [projectId]);

  if (!to) return null;
  return <Navigate to={to} replace />;
}

export default SeriesLandingRedirect;
